import React from "react";
import { ReceiptText } from "lucide-react";

import { formatTax } from "./configHelpers";
import { Card, GstCardSkeleton, InfoBox } from "./ClientConfigShared";

export default function GstDetailsCard({
  gstForm,
  halfTax,
  gstLoading,
  onEdit,
}) {
  return (
    <Card
      title="GST Details"
      icon={ReceiptText}
      rightAction={
        <button
          onClick={onEdit}
          disabled={gstLoading}
          className="rounded-xl bg-[#075E54] px-4 py-2 text-xs font-semibold text-white hover:opacity-90 disabled:opacity-60"
        >
          Edit GST
        </button>
      }
    >
      {gstLoading ? (
        <GstCardSkeleton />
      ) : (
        <>
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            <InfoBox label="GST No." value={gstForm.gst || "—"} />
            <InfoBox
              label="GST Type"
              value={gstForm.gstType === "excl" ? "Excl" : "Incl"}
            />
            <InfoBox label="SGST" value={`${formatTax(halfTax)}%`} />
            <InfoBox label="CGST" value={`${formatTax(halfTax)}%`} />
          </div>

          <div className="mt-1 rounded-2xl border border-emerald-200 bg-emerald-50 px-4 py-1.5 text-xs font-medium text-emerald-700">
            Total GST is {formatTax(gstForm.taxGst)}%. Showing half as SGST and
            half as CGST.
          </div>

          {/* <div className="mt-4 rounded-2xl border border-blue-200 bg-blue-50 px-4 py-3 text-xs font-medium text-blue-700">
            This GST value is protected and will be reused during Save
            Configuration, even though GST Number is hidden from the form.
          </div> */}
        </>
      )}
    </Card>
  );
}